<div class="go-back">
	<a href="javascript:void(0);" (click)="onCancel()">
		<i class="fa fa-arrow-left"></i>
		<h6 class="text-uppercase">add a rule</h6>
	</a>
</div>
<div class="wrapper input-form">
	<h5>Title</h5>
	<div>
		<input type="text" [(ngModel)]="title" [disabled]="saving">
	</div>
	<h5>Description</h5>
	<div>
		<textarea name="resolution" rows="5" [(ngModel)]="description" [disabled]="saving">
	</textarea>
	</div>
	<div class="field-section">
		<h5>Status</h5>
		<div>
			<cv-dropdown
				class="cv-dropdown-sm"
				[placeholder]="'Status'"
				[width]="'100%'"
				[selectedValue]="'Info'"
				[options]="['Info', 'Warning', 'Error']"
				(valuesChange)="status = $event">
			</cv-dropdown>
		</div>
	</div>
	<div class="field-section">
		<h5>Section</h5>
		<div>
			<cv-dropdown
					class="cv-dropdown-sm"
					[placeholder]="'Section'"
					[width]="'100%'"
					[optionText]="'label'"
					[selectedValue]="selectedSection"
					[options]="navItems"
					(valuesChange)="selectedSection = $event">
			</cv-dropdown>
		</div>
	</div>
	<div class="text-right action-button">
		<p-button
			[disabled]="!isFormValid() || saving || !lockedBy.byTheUser" (onClick)="createRule()">
			<i class="pi pi-check" ></i>
			{{saving ? 'saving..' : 'post' }}
		</p-button>
	</div>
</div>
